module.exports = __webpack_public_path__ + "img/73.afe64723.jpg";